import React from 'react';
import PropTypes from 'prop-types';

import TabComponent from './Component';

class TabContainer extends React.PureComponent {
  static propTypes = {
    panes: PropTypes.arrayOf(
      PropTypes.shape({
        renderPane: PropTypes.func.isRequired,
        renderMenuItem: PropTypes.func.isRequired,

        onMenuItemClick: PropTypes.func
      }).isRequired
    ).isRequired
  }

  constructor (props) {
    super(props);

    this.state = {
      visiblePaneIndex: 0
    };

    this.setVisiblePaneIndex = visiblePaneIndex => this.setState({ visiblePaneIndex });
  }

  render () {
    return (
      <TabComponent
        {...this.state}
        panes={this.props.panes}
        setVisiblePaneIndex={this.setVisiblePaneIndex}
      >

        {this.props.panes[this.state.visiblePaneIndex].renderPane()}
      </TabComponent>
    );
  }
}

export default TabContainer;
